import React from "react";
import { Box, Button, Typography } from "@mui/material";

import { ACTION_GROUPS, SYNC_ACTIONS } from "./syncActions";
import { mono,Panel, ScopeChip } from "./SyncParts";

const ActionsTab = ({ onRun }) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
    <Typography sx={{ color: "#64748b", fontSize: 13 }}>
      Every action is queued: you get a task ID straight away and follow the outcome in the Task tracker. "Accepted" does not mean it succeeded.
    </Typography>
    {ACTION_GROUPS.map((group) => (
      <Box key={group}>
        <Typography sx={{ fontSize: 12.5, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: 0.8, mb: 1.25 }}>{group}</Typography>
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" }, gap: 2 }}>
          {SYNC_ACTIONS.filter((action) => action.group === group).map((action) => (
            <Panel key={action.id} sx={{ p: "16px 18px", display: "flex", flexDirection: "column", gap: 1.25, "&:hover": { boxShadow: "0 8px 22px rgba(15,23,42,.07)" } }}>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 1 }}>
                <Typography sx={{ fontWeight: 700, fontSize: 14.5 }}>{action.title}</Typography>
                <ScopeChip scope={action.scope} />
              </Box>
              <Typography sx={{ color: "#64748b", fontSize: 12.8, lineHeight: 1.45, minHeight: 56 }}>{action.description}</Typography>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: "auto" }}>
                <Typography sx={{ ...mono, color: "#94a3b8" }}>{action.task.replace("sync.", "")}</Typography>
                <Button size="small" variant="contained" onClick={() => onRun(action.id)} aria-label={`Run ${action.title}`} sx={{ background: "#86BC25", textTransform: "none", fontWeight: 700, boxShadow: "none", "&:hover": { background: "#6a9a1e", boxShadow: "none" } }}>
                  Run…
                </Button>
              </Box>
            </Panel>
          ))}
        </Box>
      </Box>
    ))}
  </Box>
);

export default ActionsTab;
